export default {
  meta: {
    title: $localize`:@@meta.quiz.title:Викторина → CSFAIL`,
    description: $localize`:@@meta.quiz.desc:Отвечай на легкие вопросы викторины по CSGO и лутай бесплатные бонусы! Хочешь еще халяву? Дождись новые викторины по разным темам и проходи их в течении месяца.`
  }
};